// Location data for Country, State, City dropdowns

export interface Country {
  name: string;
  code: string;
}

export interface State {
  name: string;
  countryCode: string;
}

export interface City {
  name: string;
  stateCode: string;
}

export const countries: Country[] = [
  { name: 'India', code: 'IN' },
  { name: 'United States', code: 'US' },
  { name: 'United Kingdom', code: 'UK' },
  { name: 'Canada', code: 'CA' },
  { name: 'Australia', code: 'AU' },
  { name: 'United Arab Emirates', code: 'AE' },
  { name: 'Pakistan', code: 'PK' },
  { name: 'Bangladesh', code: 'BD' },
  { name: 'Singapore', code: 'SG' },
  { name: 'Malaysia', code: 'MY' },
];

export const states: Record<string, State[]> = {
  IN: [
    { name: 'Andhra Pradesh', countryCode: 'IN' },
    { name: 'Arunachal Pradesh', countryCode: 'IN' },
    { name: 'Assam', countryCode: 'IN' },
    { name: 'Bihar', countryCode: 'IN' },
    { name: 'Chhattisgarh', countryCode: 'IN' },
    { name: 'Goa', countryCode: 'IN' },
    { name: 'Gujarat', countryCode: 'IN' },
    { name: 'Haryana', countryCode: 'IN' },
    { name: 'Himachal Pradesh', countryCode: 'IN' },
    { name: 'Jharkhand', countryCode: 'IN' },
    { name: 'Karnataka', countryCode: 'IN' },
    { name: 'Kerala', countryCode: 'IN' },
    { name: 'Madhya Pradesh', countryCode: 'IN' },
    { name: 'Maharashtra', countryCode: 'IN' },
    { name: 'Manipur', countryCode: 'IN' },
    { name: 'Meghalaya', countryCode: 'IN' },
    { name: 'Mizoram', countryCode: 'IN' },
    { name: 'Nagaland', countryCode: 'IN' },
    { name: 'Odisha', countryCode: 'IN' },
    { name: 'Punjab', countryCode: 'IN' },
    { name: 'Rajasthan', countryCode: 'IN' },
    { name: 'Sikkim', countryCode: 'IN' },
    { name: 'Tamil Nadu', countryCode: 'IN' },
    { name: 'Telangana', countryCode: 'IN' },
    { name: 'Tripura', countryCode: 'IN' },
    { name: 'Uttar Pradesh', countryCode: 'IN' },
    { name: 'Uttarakhand', countryCode: 'IN' },
    { name: 'West Bengal', countryCode: 'IN' },
    { name: 'Andaman and Nicobar Islands', countryCode: 'IN' },
    { name: 'Chandigarh', countryCode: 'IN' },
    { name: 'Dadra and Nagar Haveli and Daman and Diu', countryCode: 'IN' },
    { name: 'Delhi', countryCode: 'IN' },
    { name: 'Jammu and Kashmir', countryCode: 'IN' },
    { name: 'Ladakh', countryCode: 'IN' },
    { name: 'Lakshadweep', countryCode: 'IN' },
    { name: 'Puducherry', countryCode: 'IN' },
  ],
};

export const cities: Record<string, string[]> = {
  'Andhra Pradesh': [
    'Visakhapatnam', 'Vijayawada', 'Guntur', 'Nellore', 'Kurnool', 'Rajahmundry', 
    'Tirupati', 'Kadapa', 'Kakinada', 'Anantapur', 'Vizianagaram', 'Eluru',
    'Ongole', 'Nandyal', 'Machilipatnam', 'Adoni', 'Tenali', 'Proddatur',
    'Chittoor', 'Hindupur', 'Bhimavaram', 'Madanapalle', 'Guntakal', 'Dharmavaram'
  ],
  'Arunachal Pradesh': [
    'Itanagar', 'Naharlagun', 'Pasighat', 'Namsai', 'Roing', 'Ziro', 'Bomdila',
    'Tezu', 'Seppa', 'Changlang', 'Khonsa', 'Anini', 'Along', 'Daporijo'
  ],
  'Assam': [
    'Guwahati', 'Silchar', 'Dibrugarh', 'Jorhat', 'Nagaon', 'Tinsukia', 'Tezpur',
    'Bongaigaon', 'Goalpara', 'Diphu', 'Barpeta', 'Dhubri', 'Karimganj', 'Sivasagar',
    'Golaghat', 'Dhemaji', 'North Lakhimpur', 'Kokrajhar', 'Haflong', 'Hojai'
  ],
  'Bihar': [
    'Patna', 'Gaya', 'Bhagalpur', 'Muzaffarpur', 'Purnia', 'Darbhanga', 'Bihar Sharif',
    'Arrah', 'Begusarai', 'Katihar', 'Munger', 'Chhapra', 'Danapur', 'Saharsa',
    'Hajipur', 'Sasaram', 'Dehri', 'Siwan', 'Motihari', 'Nawada', 'Bagaha',
    'Buxar', 'Kishanganj', 'Sitamarhi', 'Jamalpur', 'Jehanabad', 'Aurangabad'
  ],
  'Chhattisgarh': [
    'Raipur', 'Bhilai', 'Bilaspur', 'Korba', 'Durg', 'Rajnandgaon', 'Jagdalpur',
    'Raigarh', 'Ambikapur', 'Dhamtari', 'Mahasamund', 'Chirmiri', 'Bhatapara',
    'Dalli-Rajhara', 'Naila Janjgir', 'Tilda Newra', 'Mungeli', 'Manendragarh'
  ],
  'Goa': [
    'Panaji', 'Margao', 'Vasco da Gama', 'Mapusa', 'Ponda', 'Bicholim', 'Curchorem',
    'Sanquelim', 'Valpoi', 'Pernem', 'Cuncolim', 'Canacona', 'Quepem', 'Sanguem'
  ],
  'Gujarat': [
    'Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Bhavnagar', 'Jamnagar', 'Junagadh',
    'Gandhinagar', 'Anand', 'Nadiad', 'Morbi', 'Surendranagar', 'Bharuch', 'Mehsana',
    'Bhuj', 'Porbandar', 'Palanpur', 'Valsad', 'Vapi', 'Navsari', 'Veraval',
    'Godhra', 'Patan', 'Kalol', 'Dahod', 'Botad', 'Amreli', 'Deesa', 'Jetpur'
  ],
  'Haryana': [
    'Faridabad', 'Gurgaon', 'Hisar', 'Rohtak', 'Panipat', 'Karnal', 'Sonipat',
    'Yamunanagar', 'Panchkula', 'Bhiwani', 'Bahadurgarh', 'Jind', 'Sirsa', 'Thanesar',
    'Kaithal', 'Palwal', 'Rewari', 'Hansi', 'Narnaul', 'Fatehabad', 'Gohana',
    'Tohana', 'Narwana', 'Mandi Dabwali', 'Charkhi Dadri', 'Shahbad', 'Pehowa'
  ],
  'Himachal Pradesh': [
    'Shimla', 'Mandi', 'Solan', 'Nahan', 'Sundarnagar', 'Palampur', 'Kullu', 'Hamirpur',
    'Una', 'Bilaspur', 'Chamba', 'Dharamshala', 'Kangra', 'Manali', 'Baddi', 'Nalagarh',
    'Parwanoo', 'Amb', 'Arki', 'Dalhousie', 'Jogindernagar', 'Rampur', 'Jawalamukhi'
  ],
  'Jharkhand': [
    'Ranchi', 'Jamshedpur', 'Dhanbad', 'Bokaro', 'Deoghar', 'Phusro', 'Hazaribagh',
    'Giridih', 'Ramgarh', 'Medininagar', 'Chirkunda', 'Chas', 'Saunda', 'Sahibganj',
    'Jhumri Tilaiya', 'Dumka', 'Chaibasa', 'Gumia', 'Madhupur', 'Mihijam', 'Jamtara'
  ],
  'Karnataka': [
    'Bangalore', 'Mysore', 'Hubli', 'Mangalore', 'Belgaum', 'Gulbarga', 'Davanagere',
    'Bellary', 'Bijapur', 'Shimoga', 'Tumkur', 'Raichur', 'Bidar', 'Hospet', 'Hassan',
    'Gadag-Betageri', 'Udupi', 'Robertson Pet', 'Bhadravati', 'Chitradurga', 'Kolar',
    'Mandya', 'Chikmagalur', 'Gangavati', 'Bagalkot', 'Ranibennur'
  ],
  'Kerala': [
    'Thiruvananthapuram', 'Kochi', 'Kozhikode', 'Kollam', 'Thrissur', 'Palakkad',
    'Alappuzha', 'Malappuram', 'Kannur', 'Kottayam', 'Kasaragod', 'Pathanamthitta',
    'Idukki', 'Wayanad', 'Thalassery', 'Guruvayur', 'Vatakara', 'Koyilandy', 'Neyyattinkara',
    'Kayamkulam', 'Nedumangad', 'Kannur Cantonment', 'Kanhangad', 'Payyanur', 'Mattannur'
  ],
  'Madhya Pradesh': [
    'Indore', 'Bhopal', 'Jabalpur', 'Gwalior', 'Ujjain', 'Sagar', 'Dewas', 'Satna',
    'Ratlam', 'Rewa', 'Murwara', 'Singrauli', 'Burhanpur', 'Khandwa', 'Morena',
    'Bhind', 'Chhindwara', 'Guna', 'Shivpuri', 'Vidisha', 'Chhatarpur', 'Damoh',
    'Mandsaur', 'Khargone', 'Neemuch', 'Pithampur', 'Hoshangabad', 'Itarsi'
  ],
  'Maharashtra': [
    'Mumbai', 'Pune', 'Nagpur', 'Thane', 'Nashik', 'Aurangabad', 'Solapur', 'Amravati',
    'Kolhapur', 'Nanded', 'Sangli', 'Jalgaon', 'Akola', 'Latur', 'Dhule', 'Ahmednagar',
    'Chandrapur', 'Parbhani', 'Ichalkaranji', 'Jalna', 'Bhusawal', 'Panvel', 'Bhiwandi',
    'Ulhasnagar', 'Malegaon', 'Navi Mumbai', 'Kalyan-Dombivli', 'Vasai-Virar', 'Mira-Bhayandar',
    'Pimpri-Chinchwad', 'Satara', 'Beed', 'Yavatmal', 'Kamptee', 'Gondia', 'Barshi',
    'Wardha', 'Hinganghat', 'Osmanabad', 'Ratnagiri', 'Sindhudurg', 'Chandgad'
  ],
  'Manipur': [
    'Imphal', 'Thoubal', 'Bishnupur', 'Churachandpur', 'Senapati', 'Ukhrul', 'Kakching',
    'Chandel', 'Jiribam', 'Tamenglong', 'Moreh', 'Mayang Imphal', 'Yairipok', 'Wangjing'
  ],
  'Meghalaya': [
    'Shillong', 'Tura', 'Nongstoin', 'Jowai', 'Baghmara', 'Williamnagar', 'Nongpoh',
    'Mairang', 'Resubelpara', 'Mawlai', 'Cherrapunji'
  ],
  'Mizoram': [
    'Aizawl', 'Lunglei', 'Saiha', 'Champhai', 'Kolasib', 'Serchhip', 'Mamit',
    'Lawngtlai', 'Zawlnuam', 'Khawzawl', 'Darlawn', 'Tlabung'
  ],
  'Nagaland': [
    'Kohima', 'Dimapur', 'Mokokchung', 'Tuensang', 'Wokha', 'Zunheboto', 'Phek',
    'Mon', 'Longleng', 'Kiphire', 'Peren'
  ],
  'Odisha': [
    'Bhubaneswar', 'Cuttack', 'Rourkela', 'Brahmapur', 'Sambalpur', 'Puri', 'Balasore',
    'Bhadrak', 'Baripada', 'Jharsuguda', 'Jeypore', 'Bargarh', 'Balangir', 'Paradip',
    'Bhawanipatna', 'Dhenkanal', 'Barbil', 'Kendujhar', 'Sunabeda', 'Rayagada',
    'Byasanagar', 'Jatani', 'Anugul', 'Titlagarh', 'Nabarangpur', 'Talcher'
  ],
  'Punjab': [
    'Ludhiana', 'Amritsar', 'Jalandhar', 'Patiala', 'Bathinda', 'Mohali', 'Pathankot',
    'Hoshiarpur', 'Batala', 'Moga', 'Malerkotla', 'Khanna', 'Phagwara', 'Muktsar',
    'Barnala', 'Rajpura', 'Firozpur', 'Kapurthala', 'Faridkot', 'Sunam', 'Mansa',
    'Gurdaspur', 'Sangrur', 'Fazilka', 'Nabha', 'Abohar', 'Budhlada', 'Kotkapura'
  ],
  'Rajasthan': [
    'Jaipur', 'Jodhpur', 'Kota', 'Bikaner', 'Ajmer', 'Udaipur', 'Bhilwara', 'Alwar',
    'Bharatpur', 'Sri Ganganagar', 'Pali', 'Sikar', 'Tonk', 'Beawar', 'Hanumangarh',
    'Kishangarh', 'Gangapur City', 'Chittorgarh', 'Sawai Madhopur', 'Jhunjhunu',
    'Baran', 'Nagaur', 'Churu', 'Sardarshahar', 'Mount Abu', 'Bundi', 'Banswara',
    'Dungarpur', 'Jhalawar', 'Pratapgarh', 'Sujangarh', 'Makrana', 'Nokha'
  ],
  'Sikkim': [
    'Gangtok', 'Namchi', 'Gyalshing', 'Mangan', 'Rangpo', 'Jorethang', 'Singtam',
    'Pakyong', 'Ravangla'
  ],
  'Tamil Nadu': [
    'Chennai', 'Coimbatore', 'Madurai', 'Tiruchirappalli', 'Salem', 'Tirunelveli',
    'Tiruppur', 'Vellore', 'Erode', 'Thoothukkudi', 'Dindigul', 'Thanjavur', 'Ranipet',
    'Sivakasi', 'Karur', 'Udhagamandalam', 'Hosur', 'Nagercoil', 'Kanchipuram',
    'Kumarapalayam', 'Karaikkudi', 'Neyveli', 'Cuddalore', 'Kumbakonam', 'Tiruvannamalai',
    'Pollachi', 'Rajapalayam', 'Gudiyatham', 'Pudukkottai', 'Vaniyambadi', 'Ambur',
    'Nagapattinam', 'Dharmapuri'
  ],
  'Telangana': [
    'Hyderabad', 'Warangal', 'Nizamabad', 'Karimnagar', 'Khammam', 'Ramagundam',
    'Mahbubnagar', 'Nalgonda', 'Adilabad', 'Suryapet', 'Siddipet', 'Miryalaguda',
    'Jagtial', 'Mancherial', 'Nirmal', 'Kamareddy', 'Kothagudem', 'Bodhan', 'Palwancha',
    'Mandamarri', 'Bhongir', 'Farooqnagar', 'Medak', 'Vikarabad', 'Jangaon', 'Wanaparthy'
  ],
  'Tripura': [
    'Agartala', 'Udaipur', 'Dharmanagar', 'Pratapgarh', 'Kailashahar', 'Belonia',
    'Khowai', 'Ambassa', 'Ranir Bazar', 'Sonamura', 'Sabroom', 'Kamalpur'
  ],
  'Uttar Pradesh': [
    'Lucknow', 'Kanpur', 'Ghaziabad', 'Agra', 'Varanasi', 'Meerut', 'Allahabad',
    'Bareilly', 'Aligarh', 'Moradabad', 'Saharanpur', 'Gorakhpur', 'Noida', 'Firozabad',
    'Jhansi', 'Muzaffarnagar', 'Mathura', 'Rampur', 'Shahjahanpur', 'Farrukhabad',
    'Mau', 'Hapur', 'Etawah', 'Mirzapur', 'Bulandshahr', 'Sambhal', 'Amroha',
    'Hardoi', 'Fatehpur', 'Raebareli', 'Orai', 'Sitapur', 'Bahraich', 'Modinagar',
    'Unnao', 'Jaunpur', 'Lakhimpur', 'Hathras', 'Banda', 'Pilibhit', 'Barabanki',
    'Khurja', 'Gonda', 'Mainpuri', 'Lalitpur', 'Etah', 'Deoria', 'Ujhani', 'Ghazipur',
    'Sultanpur', 'Azamgarh', 'Bijnor', 'Sahaswan', 'Basti', 'Chandausi', 'Akbarpur',
    'Ballia', 'Tanda', 'Greater Noida', 'Shikohabad', 'Shamli', 'Awagarh', 'Kasganj'
  ],
  'Uttarakhand': [
    'Dehradun', 'Haridwar', 'Roorkee', 'Haldwani', 'Rudrapur', 'Kashipur', 'Rishikesh',
    'Ramnagar', 'Pithoragarh', 'Jaspur', 'Manglaur', 'Mussoorie', 'Nainital', 'Almora',
    'Tehri', 'Pauri', 'Bageshwar', 'Chamoli', 'Champawat', 'Rudraprayag', 'Uttarkashi'
  ],
  'West Bengal': [
    'Kolkata', 'Asansol', 'Siliguri', 'Durgapur', 'Bardhaman', 'Malda', 'Baharampur',
    'Habra', 'Kharagpur', 'Shantipur', 'Dankuni', 'Dhulian', 'Ranaghat', 'Haldia',
    'Raiganj', 'Krishnanagar', 'Nabadwip', 'Medinipur', 'Jalpaiguri', 'Balurghat',
    'Basirhat', 'Bankura', 'Chakdaha', 'Darjeeling', 'Alipurduar', 'Purulia',
    'Jangipur', 'Bolpur', 'Bangaon', 'Cooch Behar', 'Tamluk', 'Arambagh', 'Contai',
    'Howrah', 'Hooghly', 'Chandannagar', 'Bhatpara', 'Baranagar', 'Barrackpore'
  ],
  'Andaman and Nicobar Islands': [
    'Port Blair', 'Diglipur', 'Rangat', 'Mayabunder', 'Car Nicobar', 'Hut Bay'
  ],
  'Chandigarh': [
    'Chandigarh'
  ],
  'Dadra and Nagar Haveli and Daman and Diu': [
    'Daman', 'Diu', 'Silvassa', 'Dadra', 'Nagar Haveli'
  ],
  'Delhi': [
    'New Delhi', 'Delhi', 'Central Delhi', 'East Delhi', 'North Delhi', 'North East Delhi',
    'North West Delhi', 'Shahdara', 'South Delhi', 'South East Delhi', 'South West Delhi',
    'West Delhi', 'Dwarka', 'Rohini', 'Narela'
  ],
  'Jammu and Kashmir': [
    'Srinagar', 'Jammu', 'Anantnag', 'Baramulla', 'Sopore', 'Kupwara', 'Rajouri',
    'Punch', 'Udhampur', 'Kathua', 'Leh', 'Kargil', 'Pulwama', 'Budgam', 'Ganderbal',
    'Bandipora', 'Shopian', 'Kulgam', 'Ramban', 'Reasi', 'Kishtwar', 'Doda', 'Samba'
  ],
  'Ladakh': [
    'Leh', 'Kargil', 'Nubra', 'Zanskar'
  ],
  'Lakshadweep': [
    'Kavaratti', 'Agatti', 'Amini', 'Andrott', 'Minicoy', 'Kalpeni'
  ],
  'Puducherry': [
    'Puducherry', 'Karaikal', 'Mahe', 'Yanam', 'Oulgaret', 'Ariankuppam'
  ],
};
